import { TextInput } from '@interstate/components/TextInput';
import { useLeaseTermField } from '@makemydeal/dr-dash-components';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { ScenarioManualEditMarker } from '../../ScenarioManualEditMarker';
import { ScenarioRow } from '../../ScenarioRow';

export const LeaseTermRow = () => {
    const { label, overrideIndicatorProps, inputProps } = useLeaseTermField({ isSummaryTab: true });
    const inputId = useScenarioCellId('term');

    return (
        <ScenarioRow rowKey="term" label={label} inputId={inputId}>
            <ScenarioManualEditMarker {...overrideIndicatorProps} isManualEdit={false}>
                <TextInput {...inputProps} id={inputId} label={label} displayLabel={false} />
            </ScenarioManualEditMarker>
        </ScenarioRow>
    );
};
